module.exports = __webpack_public_path__ + "img/icon-huihua.b58fb3a2.png";